import { CustomerLayout as AutoDispatchCustomer } from "~/features/auto-dispatch/layout/customer-layout.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const AutoDispatchCustomerPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlAutoDispatch");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? (
		<AutoDispatchCustomer />
	) : (
		<Construction message={"This feature is under construction. Stay tuned!"} />
	);
};
